export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const SITE_URL = process.env.NEXT_PUBLIC_URL;

export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GOOGLE_ID;

export const USER_CONSENT_COOKIE_KEY: string = 'accepted_cookies_settings';

export const CHAT_API_URL = process.env.NEXT_PUBLIC_CHAT_API_URL;
export const CHAT_APP_KEY = process.env.NEXT_PUBLIC_VITE_REVERB_APP_KEY;

export const SUPPORTED_VIDEO_EXTENSIONS = ['.mp4', '.webm'];

export const IS_PROD_ENV = process.env.NEXT_PUBLIC_IS_PROD_ENV === 'true';

export const USER_ACTIVITY_DATA_KEY = 'user-activity-data';

export const CAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY;

export enum EllipseVariants {
  DRAW = 'draw',
  BORDER = 'border',
  NOISE = 'noise',
  GRADIENT = 'gradient',
}
